import { darken } from '@mui/system'
import { isEmpty } from 'lodash'

import { TroughLevel } from '#/@types/backend'
import TypeString from '#/components/FormatCell/Types/string'
import Colors from '#/styles/Colors'

export type TroughLevelValue = {
  status: TroughLevel
  text: string
}

interface TypeTroughLevelProps {
  value?: TroughLevelValue | null
}

export function TypeTroughLevel({ value }: TypeTroughLevelProps) {
  if (isEmpty(value) || !value?.text) return '-'
  const color = Colors.trough_level[value.status]

  return (
    <TypeString
      value={value.text}
      customStyle={{
        color: color ? darken(color, 0.5) : undefined,
      }}
    />
  )
}
